import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { applyUserUiSfxPrefs, PR_SFX_KINDS, PR_SFX_SOUNDS } from '../audio/pacificRimSfx';

const COLLECTION = 'userUiPrefs';

function prefsDocRef(uid) {
  return doc(db, COLLECTION, uid);
}

function isSoundId(v) {
  return typeof v === 'string' && PR_SFX_SOUNDS.includes(v);
}

function normalizeSoundMap(raw, designId) {
  if (!raw || typeof raw !== 'object') return null;
  const obj = raw;
  const out = {};
  let any = false;
  for (const kind of PR_SFX_KINDS) {
    if (isSoundId(obj[kind])) {
      out[kind] = obj[kind];
      any = true;
    }
  }
  return any ? out : null;
}

export function parseUserUiSfxPrefs(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const obj = raw;
  const sfx = obj.sfx && typeof obj.sfx === 'object' ? obj.sfx : obj;
  const mapsRaw =
    obj.soundMapsByDesign && typeof obj.soundMapsByDesign === 'object'
      ? obj.soundMapsByDesign
      : {};
  const soundMapsByDesign = {};
  for (const [designId, map] of Object.entries(mapsRaw)) {
    const normalized = normalizeSoundMap(map, designId);
    if (normalized) soundMapsByDesign[designId] = normalized;
  }
  const updatedAt =
    typeof obj.updatedAt === 'number' && Number.isFinite(obj.updatedAt)
      ? obj.updatedAt
      : 0;
  return {
    version: 1,
    enabled: typeof sfx.enabled === 'boolean' ? sfx.enabled : true,
    ambient: typeof sfx.ambient === 'boolean' ? sfx.ambient : false,
    volume: typeof sfx.volume === 'number' ? sfx.volume : 1,
    soundMapsByDesign,
    updatedAt,
  };
}

/** Nur lesen — Einstellungen werden in der Task-App vorgenommen. */
export function subscribeUserUiSfxPrefs(uid, onPrefs) {
  return onSnapshot(
    prefsDocRef(uid),
    (snap) => {
      if (!snap.exists()) return;
      const parsed = parseUserUiSfxPrefs(snap.data());
      if (parsed) onPrefs(parsed);
    },
    () => {
      /* offline */
    }
  );
}

export function applyRemoteUserUiSfxPrefs(prefs) {
  applyUserUiSfxPrefs(prefs);
}
